import angular from 'angular'

import template from './vd-section-back.html'

/**
 * A back button element that is generally located in a level 2 page header section.
 *
 * @role button
 */
angular.module('vend.ui').directive('vdSectionBack', function () {
  return {
    template,
    replace: true,
  }
})
